import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { FETCH_ODOO_OBJECTS } from "graphql/query";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";

const OdooCustomerView = ({ odooPartnerId }) => {
  const filters = [["id", "=", odooPartnerId]];

  const { odooUrl } = useContext(OdooContext);
  const { loading, error, data } = useQuery(FETCH_ODOO_OBJECTS, {
    variables: {
      model: "res.partner",
      method: "search_read",
      filters: JSON.stringify(filters),
      fields: ["name"],
    },
  });

  if (loading)
    return (
      <div className="flex">
        <InlineSpinner size={18} text={null} />
      </div>
    );
  if (error) return <Errors error={error} />;

  const customer = JSON.parse(data.odooQuery)[0];

  return (
    <div>
      <a
        href={`${odooUrl}//web#id=${customer.id}&cids=1&menu_id=408&action=744&model=res.partner&view_type=form`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {customer.name}
      </a>
    </div>
  );
};

export default OdooCustomerView;
